import {
  FilePdfOutlined,
  MoreOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { Popover } from "antd";
import moment from "moment";
import React from "react";

function InstallmentCard({ amount, dueDate, issueDate, status }) {
  const content = (
    <div style={{ color: "#AEAEAE" }}>
      <p style={{ marginBottom: "15px", marginTop: "10px", cursor: "pointer" }}>
        <FilePdfOutlined style={{ marginRight: "10px", fontSize: "20px" }} />
        View receipt
      </p>
      <p style={{ cursor: "pointer" }}>
        <ReloadOutlined style={{ marginRight: "10px", fontSize: "20px" }} />{" "}
        Refund
      </p>
    </div>
  );
  const text = <span>Title</span>;
  return (
    <div
      className="box-shadow"
      style={{ width: "290px", padding: "20px", margin: "15px" }}
    >
      <div
        className="flex_row_center"
        style={{ justifyContent: "space-between" }}
      >
        <div>
          Request For <span style={{ fontWeight: "600" }}>Fee</span>
        </div>
        {/* <Popover
          placement="leftTop"
          //   title={text}
          content={content}
          trigger="click"
        >
          <MoreOutlined
            style={{ fontWeight: "800", fontSize: "24px", cursor: "pointer" }}
          />
        </Popover> */}
      </div>
      <div
        style={{
          fontWeight: "600",
          fontSize: "24px",
          fontFamily: "roboto",
          margin: "5px",
          marginLeft: "0",
          width: "80%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        ₹ {amount.toFixed(2)}
      </div>
      <div className="flex_row_center" style={{ marginBottom: "10px" }}>
        <div>
          <p
            style={{
              marginBottom: "0",
              fontSize: "10px",
              fontWeight: "600",
              color: "#AEAEAE",
            }}
          >
            ISSUE DATE
          </p>
          <p
            style={{
              marginBottom: "0",
              fontSize: "10px",
              fontWeight: "600",
              color: "#AEAEAE",
            }}
          >
            {moment(issueDate).format("DD/MM/YYYY")}
          </p>
        </div>
        <div style={{ marginLeft: "20px" }}>
          <p
            style={{
              marginBottom: "0",
              fontSize: "10px",
              fontWeight: "600",
              color: "#AEAEAE",
            }}
          >
            PAYMENT DATE
          </p>
          <p
            style={{
              marginBottom: "0",
              fontSize: "10px",
              fontWeight: "600",
              color: "#AEAEAE",
            }}
          >
            {moment(dueDate).format("DD/MM/YYYY")}
          </p>
        </div>
      </div>
      <p
        style={{
          marginBottom: "0",
          fontSize: "10px",
          fontWeight: "600",
          color: "#AEAEAE",
        }}
      >
        STATUS
      </p>
      <p
        style={{
          marginBottom: "0",
          fontSize: "12px",
          fontWeight: "600",
          color: "#28DF99",
        }}
      >
        {status}
      </p>
    </div>
  );
}

export default InstallmentCard;
